<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "category"
}
</script>

<style scoped>
</style>
